<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <!-- <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryCaseName"
          style="margin-bottom:-20px !important;"
          class="v-offset-none"
          color="purple"
          icon="mdi-folder-open"
          title="案名"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryDate"
          style="margin-bottom:-20px !important;"
          color="indigo"
          icon="mdi-calendar"
          title="資料日期"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryEMS"
          style="margin-bottom:-20px !important;"
          color="light-blue"
          icon="mdi-factory"
          title="EMS"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(responseAreaData.failRate * 100).toFixed(1) + '%'"
          :class="responseAreaData.warningColor || 'green'"
          :color="responseAreaData.color"
          :icon="responseAreaData.icon || 'mdi-check'"
          class="title-color"
          style="margin-bottom:-20px !important;"
          title="Fail Rate"/>
      </v-flex> -->
      <v-flex
        class="v-flex__first"
        style="margin-top: 55px !important;"
        xs12>
        <material-card
          class="v-flex v-c3-chart"
        >
          <div
            class="chart-btn c3-chart c3-click"
            style="margin-top: -3.5rem!important;">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              2D(x,y)散佈圖 [Mode：{{selectedDataType}}-{{ calibrationMode }}]
              <div class="float-right">
                <v-autocomplete
                    v-model="selectedDataType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'ISN', value: 'ISN' },
                      { text: 'I1SN', value: 'I1SN' },
                    ]"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                <v-btn
                  v-for="(mode,m) in calibrationModeMenu"
                  :key="'m'+m"
                  class="black text-light mr-0 ml-2 px-2"
                  @click="calibrationMode=mode">{{ mode }}</v-btn>
              </div>
              <p class="m-0">Factory：{{ propData.factoryName }} ｜ Project：{{ propData.projectName }} ｜ prodId：{{ propData.prodId }}｜ Time Interval：{{ propData.startTime }} ~ {{ propData.endTime }}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
             <!-- <div ref="chartContainer" @wheel="handleWheel">
            <vue-c3 ref="handler_bar" :handler="handler_bar"/>
             </div> -->
             <div id="fyzchart" ref="chartContainer" ></div>
             <div id="custom-legend" :class="`app-theme-${theme}`" style="text-align:center; margin-top:10px;"></div>
          </div>
          <div>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="target.x"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="目標X軸設定"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="target.y"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="目標Y軸設定"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              m-4/>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="spec.x.high"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="SPEC X值上限"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="spec.x.low"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="SPEC X值下限"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              m-4/>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="spec.y.high"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="SPEC Y值上限"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;min-width: 200px!important;">
              <v-text-field
                v-model="spec.y.low"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                label="SPEC Y值下限"
                class="v-text-field__slot v-text-field__details-none"
                type="number"
                step="0.001"
                persistent-hint
                outlined
              />
            </v-flex>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
// import VueC3 from 'vue-c3'
import * as d3 from 'd3'
import * as c3 from 'c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'ShowLcdCalibration2DXYScatterPlot',
  // components: {
  //   VueC3
  // },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      // lcdFilterUpdateTime: '',
      calibrationMode: 'NoGM',
      calibrationModeMenu: [],
      xlow: 0.275,
      xhigh: 0.350,
      ylow: 0.290,
      yhigh: 0.365,
      xlow_G: 0.275,
      xhigh_G: 0.350,
      ylow_G: 0.290,
      yhigh_G: 0.365,
      target: {
        x: 0.313,
        y: 0.329
      },
      spec: {
        x: {
          high: 0.338,
          low: 0.288
        },
        y: {
          high: 0.354,
          low: 0.304
        }
      },
      responseAreaData: [],
      barXaxisItem: ['beforeWx', 'beforeWy', 'finalWx', 'finalWy'],
      barXaxisItemName: ['beforeCalibration_x', 'beforeCalibration', 'afterCalibration_x', 'afterCalibration'],
      barXaxisName: [],
      barXaxisValue: [],
      selectedDataType: '',
      chartColumns: [],
      randomColors: {},
      i1sngroupedData: [],
      isngroupedData: [{
        beforeW: {
          x: [],
          y: []
        },
        afterW: {
          x: [],
          y: []
        }
      }],
      xAxisTicks: [],
      yAxisTicks: [],
      chart: null,
      handler_bar: new Vue()
    }
  },

  // created () {
  //   // 初始化時產生一次 ticks
  //   this.updateAxisTicks()
  // },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    xAxisDataArray () {
      const x = []
      const start = +this.xlow // Convert to number
      const end = +this.xhigh // Convert to number
      for (let i = start; i <= end; i += 0.005) {
        x.push(i.toFixed(3))
      }
      return x
    },
    yAxisDataArray () {
      const y = []
      const start = +this.ylow // Convert to number
      const end = +this.yhigh // Convert to number
      for (let i = start; i <= end; i += 0.005) {
        y.push(i.toFixed(3))
      }
      return y
    },
    options_bar () {
      return {
        data: {
          names: {
            beforeCalibration: '校準前',
            afterCalibration: '校準後',
            target: '目標'
          },
          xs: {
            beforeCalibration: 'beforeCalibration_x',
            afterCalibration: 'afterCalibration_x',
            target: 'target_x'
          },
          columns: this.barXaxisValue.concat([['target_x', this.target.x]]).concat([['target', this.target.y]]),
          labels: true,
          // labels: {
          //   // format: function (v, id, i, j) { return v + '%' }
          // },
          // onclick: function (d) { alert(d.index) },
          // onclick: (d) => { this.summaryList(d.index, 'range') },
          type: 'scatter',
          colors: {
            // afterCalibration: '#ff0000',
            target: 'green'
          }
          // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
          // color: function (color, d) {
          //   // d will be 'id' when called for legends
          //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
          // }
          // color: (color, d) => {
          //   // d will be 'id' when called for legends
          //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
          // }
        },
        axis: {
          x: {
            height: 50,
            label: '數列X值',
            min: parseFloat(this.xlow),
            max: parseFloat(this.xhigh),
            tick: {
              rotate: -45,
              values: this.xAxisDataArray
            }
          },
          y: {
            label: '數列Y值',
            min: parseFloat(this.ylow),
            max: parseFloat(this.yhigh),
            tick: {
              values: this.yAxisDataArray
            }
          }
        },
        zoom: {
          enabled: false
          // rescale: true // 縮放時自適應 Y 軸範圍
        },
        tooltip: {
          contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
            let data = []
            const shownIds = (this.chart && this.chart.data && this.chart.data.shown)
              ? this.chart.data.shown().map(item => item.id)
              : []
            if (d[0].x === this.target.x && shownIds.includes('target')) {
              data.push({ type: 'target', name: '目標', sn: '', i1sn: '', color: 'green', x: this.target.x, y: this.target.y })
            }
            this.responseAreaData.forEach((n) => {
              if (d[0].x === n.beforeWx && shownIds.includes('beforeCalibration')) {
                data.push({ type: 'beforeCalibration', name: '校準前', sn: n.deviceIsn, i1sn: n.i1Sn, color: '#1f77b4', x: n.beforeWx, y: n.beforeWy })
              }
              if (d[0].x === n.finalWx && shownIds.includes('afterCalibration')) {
                data.push({ type: 'afterCalibration', name: '校準後', sn: n.deviceIsn, i1sn: n.i1Sn, color: '#ff7f0e', x: n.finalWx, y: n.finalWy })
              }
            })
            let table = ''
            data.sort((a, b) => b.y - a.y).forEach((n) => {
              table += `
                <tr class="c3-tooltip-name--${n.type}">
                  <td class="type"><span style="background-color:${n.color}"></span></td>
                  <td class="name text-right">${n.sn} ${n.i1sn} ${n.name}</td>
                  <td class="value">(${n.x.toFixed(4)} , ${n.y.toFixed(4)})</td>
                </tr>
              `
            })
            return `
              <table class="c3-tooltip">
                <tbody>
                  <!--<tr>
                    <th colspan="3"></th>
                  </tr>-->
                  ${table}
                </tbody>
              </table>
            `
          }
          // format: {
          //   title: (d, Value) => {
          //     return `${d}}`
          //   },
          //   valuee: (value, ratio, id) => {
          //     return `${value}`
          //   }
          // }
        },
        grid: {
          x: {
            // show: true,
            lines: [
              { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
              { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
              ...this.xAxisDataArray
                .map(val => parseFloat(val))
                .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
                .map(val => ({
                  value: val,
                  class: 'scatter-grid-line'
                }))
            ]
          },
          y: {
            // show: true,
            lines: [
              { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
              { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
              ...this.yAxisDataArray
                .map(val => parseFloat(val))
                .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
                .map(val => ({
                  value: val,
                  class: 'scatter-grid-line'
                }))
            ]
          }
        },
        legend: {
          show: false
        },
        point: {
          r: function (d) {
            return d.id === 'target' ? 8 : 3.5
          }
        },
        padding: {
          top: 0,
          bottom: 0,
          left: 150, // 給 Y 軸文字留空
          right: 20
        },
        size: {
          width: 700,
          height: 700
        }
      }
    },
    // options_bar1 () {
    //   let names = {}
    //   let xs = {}

    //   // 循環處理 chartColumns 來生成 names 和 xs
    //   this.chartColumns.forEach(col => {
    //     if (col[0].endsWith('_x')) {
    //       let sn = col[0].replace('_x', '')
    //       names[sn] = sn // 生成名字
    //       xs[sn] = col[0] // 將對應的 x 值綁定到 SN
    //     }
    //   })

    //   names['target'] = '目標'
    //   console.info(names)
    //   return {
    //     data: {
    //       names: names,
    //       xs: xs,
    //       columns: this.chartColumns, // 使用新生成的數據
    //       labels: true,
    //       type: 'scatter',
    //       colors: {
    //         target: 'green'
    //       }
    //     },
    //     axis: {
    //       x: {
    //         label: '數列X值',
    //         min: 0.275,
    //         max: 0.350,
    //         tick: {
    //           values: this.xAxisDataArray
    //         }
    //       },
    //       y: {
    //         label: '數列Y值',
    //         min: 0.290,
    //         max: 0.365,
    //         tick: {
    //           values: this.yAxisDataArray
    //         }
    //       }
    //     },
    //     tooltip: {
    //       contents: (d) => {
    //         let data = []
    //         if (d[0].x === this.target.x) {
    //           data.push({ type: 'target', name: '目標', color: 'green', x: this.target.x, y: this.target.y })
    //         }
    //         this.chartColumns.forEach(col => {
    //           if (col[0].endsWith('_x')) {
    //             const sn = col[0].replace('_x', '')
    //             const index = col.indexOf(d[0].x)
    //             if (index !== -1) {
    //               data.push({ type: sn, name: sn, color: '#1f77b4', x: col[index], y: this.chartColumns.find(y => y[0] === sn)[index] })
    //             }
    //           }
    //         })

    //         let table = ''
    //         data.sort((a, b) => b.y - a.y).forEach(n => {
    //           table += `
    //           <tr class="c3-tooltip-name--${n.type}">
    //             <td class="type"><span style="background-color:${n.color}"></span></td>
    //             <td class="name text-right">${n.name}</td>
    //             <td class="value">(${n.x} , ${n.y})</td>
    //           </tr>
    //         `
    //         })

    //         return `<table class="c3-tooltip"><tbody>${table}</tbody></table>`
    //       }
    //     },
    //     grid: {
    //       x: { show: true, lines: [{ value: this.spec.x.low, text: 'x(下限)' }, { value: this.spec.x.high, text: 'x(上限)' }] },
    //       y: { show: true, lines: [{ value: this.spec.y.low, text: 'y(下限)' }, { value: this.spec.y.high, text: 'y(上限)' }] }
    //     },
    //     legend: { position: 'bottom', padding: 16, show: true },
    //     point: {
    //       r: function (d) {
    //         return d.id === 'target' ? 8 : 3.5
    //       }
    //     },
    //     size: { height: 600 }
    //   }
    // },
    options_bar_i1sn () {
      return {
        data: {
          names: {
            i1sn_original: 'i1SN',
            target: '目標'
          },
          xs: {
            ...Object.fromEntries(
              Object.keys(this.i1sngroupedData).map(i1Sn => [i1Sn, 'x_' + i1Sn])
            ),
            target: 'target_x'
          },
          columns: Object.values(this.i1sngroupedData).flatMap(group => [group.x, group.y])
            .concat([['target_x', this.target.x], ['target', this.target.y]]),
          labels: true,
          // labels: {
          //   // format: function (v, id, i, j) { return v + '%' }
          // },
          // onclick: function (d) { alert(d.index) },
          // onclick: (d) => { this.summaryList(d.index, 'range') },
          type: 'scatter',
          colors: {
            // afterCalibration: '#ff0000',
            ...this.randomColors,
            target: 'green'
          }
          // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
          // color: function (color, d) {
          //   // d will be 'id' when called for legends
          //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
          // }
          // color: (color, d) => {
          //   // d will be 'id' when called for legends
          //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
          // }
        },
        color: {
          pattern: Object.values(this.randomColors) // 可選，作為 fallback
        },
        axis: {
          x: {
            label: '數列X值',
            min: parseFloat(this.xlow),
            max: parseFloat(this.xhigh),
            tick: {
              rotate: -45,
              values: this.xAxisDataArray
            }
          },
          y: {
            label: '數列Y值',
            min: parseFloat(this.ylow),
            max: parseFloat(this.yhigh),
            tick: {
              values: this.yAxisDataArray
            }
          }
        },
        zoom: {
          enabled: false
          // rescale: true // 縮放時自適應 Y 軸範圍
        },
        tooltip: {
          contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
            let data = []
            const shownIds = (this.chart && this.chart.data && this.chart.data.shown)
              ? this.chart.data.shown().map(item => item.id)
              : []
            if (d[0].x === this.target.x && shownIds.includes('target')) {
              data.push({ type: 'target', name: '目標', sn: '', i1sn: '', color: 'green', x: this.target.x, y: this.target.y })
            }
            this.responseAreaData.forEach(n => {
              const id = n.i1Sn
              if (d[0].x === n.beforeWx && shownIds.includes(id)) {
                data.push({ type: 'original', name: 'Original', sn: n.deviceIsn, i1sn: n.i1Sn, color: this.randomColors[n.i1Sn] || 'black', x: n.beforeWx, y: n.beforeWy })
              }
            })
            let table = ''
            data.sort((a, b) => b.y - a.y).forEach((n) => {
              table += `
                <tr class="c3-tooltip-name--${n.type}">
                  <td class="type"><span style="background-color:${n.color}"></span></td>
                  <td class="name text-right">${n.sn} ${n.i1sn} ${n.name}</td>
                  <td class="value">(${n.x.toFixed(4)} , ${n.y.toFixed(4)})</td>
                </tr>
              `
            })
            return `
              <table class="c3-tooltip">
                <tbody>
                  <!--<tr>
                    <th colspan="3"></th>
                  </tr>-->
                  ${table}
                </tbody>
              </table>
            `
          }
          // format: {
          //   title: (d, Value) => {
          //     return `${d}}`
          //   },
          //   valuee: (value, ratio, id) => {
          //     return `${value}`
          //   }
          // }
        },
        grid: {
          x: {
            // show: true,
            lines: [
              { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
              { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
              ...this.xAxisDataArray
                .map(val => parseFloat(val))
                .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
                .map(val => ({
                  value: val,
                  class: 'scatter-grid-line'
                }))
            ]
          },
          y: {
            // show: true,
            lines: [
              { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
              { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
              ...this.yAxisDataArray
                .map(val => parseFloat(val))
                .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
                .map(val => ({
                  value: val,
                  class: 'scatter-grid-line'
                }))
            ]
          }
        },
        legend: {
          show: false
        },
        point: {
          r: function (d) {
            return d.id === 'target' ? 8 : 3.5
          }
        },
        padding: {
          top: 0,
          bottom: 0,
          left: 150, // 給 Y 軸文字留空
          right: 20
        },
        size: {
          width: 700,
          height: 700
        }
      }
    }
  },
  watch: {
    target: {
      handler: function (val, oldVal) {
        if (this.selectedDataType === 'ISN') {
          this.doChart()
        } else {
          this.doChart_i1sn()
        }
      },
      deep: true
    },
    spec: {
      handler: function (val, oldVal) {
        if (this.selectedDataType === 'ISN') {
          this.doChart()
        } else {
          this.doChart_i1sn()
        }
      },
      deep: true
    },

    calibrationMode () {
      this.doSubmit()
    },
    selectedDataType (newVal) {
      this.selectchart(newVal)
    }
    // xlow () { this.scheduleUpdateAxisTicks() },
    // xhigh () { this.scheduleUpdateAxisTicks() },
    // ylow () { this.scheduleUpdateAxisTicks() },
    // yhigh () { this.scheduleUpdateAxisTicks() }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/lcd/lcdCalibrationAnalyzer/showLcdCalibration2DXYScatterPlotView')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cacheFilterInfo')
          if (cache) {
            // ✅ 優先用 sessionStorage 中的副本
            this.propData = JSON.parse(cache)
          } else {
            // ✅ 第一次從 localStorage 拿到後，存入 sessionStorage
            const raw = localStorage.getItem('lcdFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cacheFilterInfo', raw)
            }
          }
          this.selectedDataType = 'ISN'
          // this.lcdFilterUpdateTime = localStorage.getItem('lcdFilterUpdateTime')
          this.doSubmit()
          this.$http.post('/api/lcd/analyzeMgmt/calibrationMode', this.propData).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                this.calibrationModeMenu = res.data
              }
            })
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    renderCustomLegend () {
      const legendContainer = document.getElementById('custom-legend')
      if (!legendContainer || !this.chart) return
      // console.info('legendContainer', legendContainer.innerHTML)
      legendContainer.innerHTML = ''
      console.info('i1sngroupedData', this.i1sngroupedData)
      console.info('barXaxisValue', this.barXaxisValue)
      this.chart.data().forEach(d => {
        const color = this.chart.color(d)
        const span = document.createElement('span')
        const shownIds = this.chart.data.shown().map(s => s.id)
        const isVisible = shownIds.includes(d.id)
        span.style.margin = '0 10px'
        span.style.cursor = 'pointer'
        span.style.display = 'inline-block'
        span.className = 'legend-item' + (isVisible ? '' : ' disabled') // 加上 disabled 樣式
        var count = 0
        if (this.selectedDataType === 'ISN') {
          const arr = this.barXaxisValue.find(v => v[0] === d.id)
          if (arr) {
            // 計數，扣掉第一個名稱元素
            count = arr.length - 1
          }
        } else {
          if (this.i1sngroupedData[d.id]) {
            count = this.i1sngroupedData[d.id].x.length - 1 // 同樣第一個是 'x_xxx'
          }
        }
        if (d.id === 'target') {
          count = 1
        }
        span.innerHTML = `
        <span style="background-color:${color}; width:12px; height:12px; display:inline-block; margin-right:5px;"></span>
        <span >${d.id}(${count})</span>`

        span.addEventListener('click', () => {
          this.chart.toggle(d.id)
          const nowVisible = this.chart.data.shown().map(s => s.id).includes(d.id)
          if (nowVisible) {
            span.classList.remove('disabled')
          } else {
            span.classList.add('disabled')
          }
        })

        span.addEventListener('mouseover', () => {
          this.chart.focus(d.id)
          const allSpans = legendContainer.querySelectorAll('.legend-item')
          allSpans.forEach(el => {
            if (el !== span) {
              el.classList.add('legend-fade')
            }
          })
        })

        span.addEventListener('mouseout', () => {
          this.chart.revert()
          const allSpans = legendContainer.querySelectorAll('.legend-item')
          allSpans.forEach(el => {
            el.classList.remove('legend-fade')
          })
        })

        legendContainer.appendChild(span)
      })
    },
    enableD3Zoom () {
      const svg = d3.select(this.$refs.chartContainer).select('svg')
      const chart = this.chart
      console.info('svg width:', svg.attr('width'))
      console.info('svg height:', svg.attr('height'))
      if (!svg || !chart) return

      // const margin = { top: 20, right: 20, bottom: 30, left: 50 }
      const width = +svg.attr('width') + 80
      const height = +svg.attr('height') + 60

      // 建立 D3 的 scale
      const xScale = d3.scaleLinear()
        .domain([parseFloat(this.xlow), parseFloat(this.xhigh)])
        .range([0, width])

      const yScale = d3.scaleLinear()
        .domain([parseFloat(this.ylow), parseFloat(this.yhigh)])
        .range([height, 0])

      const zoom = d3.zoom()
        .scaleExtent([1, 10])
        .translateExtent([[0, 0], [width, height]])
        .extent([[0, 0], [width, height]])
        .on('zoom', () => {
          const transform = d3.event.transform
          console.info(transform)
          const newX = transform.rescaleX(xScale)
          const newY = transform.rescaleY(yScale)

          // 使用 C3 API 更新 axis 範圍
          chart.axis.min({
            x: newX.domain()[0],
            y: newY.domain()[0]
          })
          chart.axis.max({
            x: newX.domain()[1],
            y: newY.domain()[1]
          })
          // chart.flush() // ⚠️ 強制更新畫面
        })

      svg.call(zoom)
    },
    // generateTicks (low, high) {
    //   const result = []
    //   for (let i = +low; i <= +high; i += 0.005) {
    //     result.push(Number(i.toFixed(3))) // 轉成 Number 提高性能
    //   }
    //   return result
    // },

    // updateAxisTicks () {
    //   this.xAxisTicks = this.generateTicks(this.xlow, this.xhigh)
    //   this.yAxisTicks = this.generateTicks(this.ylow, this.yhigh)
    // },
    // scheduleUpdateAxisTicks () {
    //   clearTimeout(this.debounceTimer)
    //   this.debounceTimer = setTimeout(() => {
    //     this.updateAxisTicks()
    //   }, 50) // 可調整 delay 時間
    // },
    handleWheel (event) {
      event.preventDefault()

      const scaleFactor = 0.05
      const zoomDirection = event.deltaY > 0 ? -1 : 1 // 滾輪向下為正，向上為負
      const container = this.$refs.chartContainer
      const rect = container.getBoundingClientRect()
      const offsetX = event.clientX - rect.left
      const offsetY = event.clientY - rect.top

      const xlow = parseFloat(this.xlow)
      const xhigh = parseFloat(this.xhigh)
      const ylow = parseFloat(this.ylow)
      const yhigh = parseFloat(this.yhigh)
      // 相對於圖表寬高的比例（0~1）
      const percentX = offsetX / rect.width
      const percentY = offsetY / rect.height

      const rangeX = parseFloat(this.xhigh) - parseFloat(this.xlow)
      const rangeY = parseFloat(this.yhigh) - parseFloat(this.ylow)

      // 計算新的範圍
      // const newRangeX = rangeX * (1 - scaleFactor * zoomDirection)
      // const newRangeY = rangeY * (1 - scaleFactor * zoomDirection)

      const zoomX = rangeX * scaleFactor * zoomDirection
      const zoomY = rangeY * scaleFactor * zoomDirection
      let newXlow = xlow + zoomX * percentX
      let newXhigh = xhigh - zoomX * (1 - percentX)
      let newYlow = ylow + zoomY * (1 - percentY)
      let newYhigh = yhigh - zoomY * percentY
      // 更新 x 和 y 範圍
      // let newXlow = parseFloat(this.xlow) + rangeX * scaleFactor * zoomDirection
      // let newXhigh = parseFloat(this.xlow) + newRangeX

      // let newYlow = parseFloat(this.ylow) + rangeY * scaleFactor * zoomDirection
      // let newYhigh = parseFloat(this.ylow) + newRangeY
      // 限制範圍（請先定義這些常數 xlow_G 等）
      if (newXlow < this.xlow_G) {
        newXlow = this.xlow_G
        // newXhigh = newXlow + (this.xhigh - this.xlow) // 保持原始範圍
      }
      if (newXhigh > this.xhigh_G) {
        newXhigh = this.xhigh_G
        // newXlow = newXhigh - (this.xhigh - this.xlow)
      }
      if (newYlow < this.ylow_G) {
        newYlow = this.ylow_G
        // newYhigh = newYlow + (this.yhigh - this.ylow)
      }
      if (newYhigh > this.yhigh_G) {
        newYhigh = this.yhigh_G
        // newYlow = newYhigh - (this.yhigh - this.ylow)
      }

      // 套用新值
      this.xlow = newXlow
      this.xhigh = newXhigh
      this.ylow = newYlow
      this.yhigh = newYhigh
      // 更新圖表
      this.updateChart()
    },

    // 更新圖表（重新渲染）
    // updateChart () {
    //   if (this.selectedDataType === 'display3') {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       chart.internal.config.axis_x_min = parseFloat(this.xlow)
    //       chart.internal.config.axis_x_max = parseFloat(this.xhigh)
    //       chart.internal.config.axis_x_tick_values = this.xAxisDataArray.map(Number)

    //       chart.internal.config.axis_y_min = parseFloat(this.ylow)
    //       chart.internal.config.axis_y_max = parseFloat(this.yhigh)
    //       chart.internal.config.axis_y_tick_values = this.yAxisDataArray.map(Number)
    //       chart.flush()
    //     })
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       chart.internal.config.axis_x_min = parseFloat(this.xlow)
    //       chart.internal.config.axis_x_max = parseFloat(this.xhigh)
    //       chart.internal.config.axis_x_tick_values = this.xAxisDataArray.map(Number)

    //       chart.internal.config.axis_y_min = parseFloat(this.ylow)
    //       chart.internal.config.axis_y_max = parseFloat(this.yhigh)
    //       chart.internal.config.axis_y_tick_values = this.yAxisDataArray.map(Number)
    //       chart.flush()
    //     })
    //   }
    // },
    doChart (type) {
      this.barXaxisValue = []
      this.barXaxisItem.forEach((item, index) => {
        this.barXaxisValue.push([this.barXaxisItemName[index]])
        this.responseAreaData.forEach((r) => {
          if (r[item] >= 0) {
            this.barXaxisValue[index].push(r[item])
          }
        })
      })
      console.info('barXaxisValue', this.barXaxisValue)
      if (type === 'init') {
        // this.handler_bar.$emit('init', this.options_bar)
        this.chart = c3.generate({
          bindto: this.$refs.chartContainer,
          ...this.options_bar
        })
        console.info(this.chart)
        this.$nextTick(() => {
          this.enableD3Zoom()
          this.renderCustomLegend()
        })
      } else {
        const chart = this.chart
        const options = {
          xs: { target: 'target_x' },
          columns: this.barXaxisValue.concat([['target_x', this.target.x]]).concat([['target', this.target.y]])
        }
        const optionsXline = [
          { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
          { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
          ...this.xAxisDataArray
            .map(val => parseFloat(val))
            .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
            .map(val => ({
              value: val,
              class: 'scatter-grid-line'
            }))
        ]
        const optionsYline = [
          { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
          { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
          ...this.yAxisDataArray
            .map(val => parseFloat(val))
            .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
            .map(val => ({
              value: val,
              class: 'scatter-grid-line'
            }))
        ]
        chart.load(options)
        chart.xgrids(optionsXline)
        chart.ygrids(optionsYline)
        // this.handler_bar.$emit('dispatch', chart => {
        //   const options = {
        //     xs: { target: 'target_x' },
        //     columns: this.barXaxisValue.concat([['target_x', this.target.x]]).concat([['target', this.target.y]])
        //   }
        //   const optionsXline = [
        //     { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
        //     ...this.xAxisDataArray
        //       .map(val => parseFloat(val))
        //       .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
        //       .map(val => ({
        //         value: val,
        //         class: 'scatter-grid-line'
        //       }))
        //   ]
        //   const optionsYline = [
        //     { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
        //     ...this.yAxisDataArray
        //       .map(val => parseFloat(val))
        //       .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
        //       .map(val => ({
        //         value: val,
        //         class: 'scatter-grid-line'
        //       }))
        //   ]
        //   chart.load(options)
        //   chart.xgrids(optionsXline)
        //   chart.ygrids(optionsYline)
        // })
      }
    },
    doChart_i1sn (type) {
      const chartcolumns = Object.values(this.i1sngroupedData).flatMap(group => [group.x, group.y])
      console.info(this.i1sngroupedData)
      if (type === 'init') {
        // this.generateRandomData()
        // this.handler_bar.$emit('init', this.options_bar_i1sn)
        this.chart = c3.generate({
          bindto: this.$refs.chartContainer,
          ...this.options_bar_i1sn
        })
        console.info(this.chart)
        this.$nextTick(() => {
          this.enableD3Zoom()
          this.renderCustomLegend()
        })
      } else {
        const chart = this.chart
        const options = {
          xs: { target: 'target_x' },
          columns: chartcolumns.concat([['target_x', this.target.x]]).concat([['target', this.target.y]])
        }
        const optionsXline = [
          { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
          { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
          ...this.xAxisDataArray
            .map(val => parseFloat(val))
            .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
            .map(val => ({
              value: val,
              class: 'scatter-grid-line'
            }))
        ]
        const optionsYline = [
          { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
          { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
          ...this.yAxisDataArray
            .map(val => parseFloat(val))
            .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
            .map(val => ({
              value: val,
              class: 'scatter-grid-line'
            }))
        ]
        chart.load(options)
        chart.xgrids(optionsXline)
        chart.ygrids(optionsYline)
        // this.handler_bar.$emit('dispatch', chart => {
        //   const options = {
        //     xs: { target: 'target_x' },
        //     columns: chartcolumns.concat([['target_x', this.target.x]]).concat([['target', this.target.y]])
        //   }
        //   const optionsXline = [
        //     { value: this.spec.x.low, text: 'x(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.x.high, text: 'x(上限)', position: 'end', class: 'scatter-assign-board-line' },
        //     ...this.xAxisDataArray
        //       .map(val => parseFloat(val))
        //       .filter(val => parseFloat(val) !== this.spec.x.low && parseFloat(val) !== this.spec.x.high)
        //       .map(val => ({
        //         value: val,
        //         class: 'scatter-grid-line'
        //       }))
        //   ]
        //   const optionsYline = [
        //     { value: this.spec.y.low, text: 'y(下限)', position: 'start', class: 'scatter-assign-board-line' },
        //     { value: this.spec.y.high, text: 'y(上限)', position: 'end', class: 'scatter-assign-board-line' },
        //     ...this.yAxisDataArray
        //       .map(val => parseFloat(val))
        //       .filter(val => parseFloat(val) !== this.spec.y.low && parseFloat(val) !== this.spec.y.high)
        //       .map(val => ({
        //         value: val,
        //         class: 'scatter-grid-line'
        //       }))
        //   ]
        //   chart.load(options)
        //   chart.xgrids(optionsXline)
        //   chart.ygrids(optionsYline)
        // })
      }
    },
    doSubmit () {
      console.info(this.calibrationMode)
      this.loadingView = true
      this.$http.post(`/api/lcd/analyzeMgmt/2DXYDataList/${this.calibrationMode}`, this.propData).then(res => res.data)
        .then(res => {
          console.info(res)
          this.loadingView = false
          if (res.status === 'success') {
            this.responseAreaData = res.data
            this.i1sngroupedData = []
            console.info('first this.i1sngroupedData', this.i1sngroupedData)
            this.responseAreaData.forEach(n => {
              console.info('n.i1Sn', n.i1Sn)
              if (!this.i1sngroupedData[n.i1Sn]) {
                this.i1sngroupedData[n.i1Sn] = {
                  x: ['x_' + n.i1Sn],
                  y: [n.i1Sn]
                }
                this.randomColors[n.i1Sn] = this.getRandomColor()
              }
              this.i1sngroupedData[n.i1Sn].x.push(n.beforeWx)
              this.i1sngroupedData[n.i1Sn].y.push(n.beforeWy)
            })
            // const beforeX = ['x_beforeW']
            // const beforeY = ['beforeW']
            // const finalX = ['x_finalW']
            // const finalY = ['finalW']
            // this.responseAreaData.forEach(n => {
            //   beforeX.push(n.beforeWx)
            //   beforeY.push(n.beforeWy)
            //   finalX.push(n.finalWx)
            //   finalY.push(n.finalWy)
            // })
            // this.isngroupedData = {
            //   beforeW: {
            //     x: beforeX,
            //     y: beforeY
            //   },
            //   finalW: {
            //     x: finalX,
            //     y: finalY
            //   }
            // }
            console.info('second this.i1sngroupedData', this.i1sngroupedData)
            if (this.selectedDataType === 'ISN') {
              this.doChart('init')
            } else {
              this.doChart_i1sn('init')
            }
          } else {
            this.responseAreaData = []
            this.doChart('init')
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '查無資料'
          }
        })
        .catch(err => {
          this.responseAreaData = []
          this.doChart('init')
          this.loadingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    getRandomColor () {
      let color
      let isGreen, isDuplicate, isTooDark
      do {
        color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`

        // 轉成 RGB
        const r = parseInt(color.slice(1, 3), 16)
        const g = parseInt(color.slice(3, 5), 16)
        const b = parseInt(color.slice(5, 7), 16)

        isTooDark = (r + g + b) < 150 // RGB總和小於100認為太暗（你可調整這門檻）
        isGreen = color.toLowerCase() === '#008000'
        isDuplicate = Object.values(this.randomColors).includes(color)
      } while (isGreen || isDuplicate || isTooDark)

      return color
    },
    selectchart (dataType) {
      // if (dataType === 'i1sn') {
      //   this.calibrationMode = 'I1SN'
      // } else {
      //   this.calibrationMode = 'NOGM'
      // }
      this.doSubmit()
      this.$http.post('/api/lcd/analyzeMgmt/calibrationMode', this.propData).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.calibrationModeMenu = res.data
          }
        })
    },
    generateRandomData () {
      const sns = ['SN123456', 'SN654321', 'SN234561']
      const columns = [['target_x', this.target.x + 0.01], ['target', this.target.y]] // 保留目標值

      sns.forEach(sn => {
        const xData = [`${sn}_x`]
        const yData = [sn]

        for (let i = 0; i < 5; i++) { // 生成5組隨機數據
          const randomX = (0.275 + Math.random() * (0.350 - 0.275)).toFixed(3)
          const randomY = (0.290 + Math.random() * (0.365 - 0.290)).toFixed(3)
          xData.push(parseFloat(randomX))
          yData.push(parseFloat(randomY))
        }

        columns.push(xData)
        columns.push(yData)
      })

      this.chartColumns = columns // 存儲數據，綁定到圖表
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
.c3 .scatter-assign-board-line line{
  stroke: hotpink;
  stroke-width: 2;
  stroke-dasharray: 6;
}
.c3 .c3-circles-target circle{
  fill: green;
  opacity: 1 !important;
}
.legend-item {
  cursor: pointer;
  user-select: none;
  transition: opacity 0.3s ease;
  display: inline-flex;
  align-items: center;
  margin: 0 10px;
  color: var(--legend-text-color);
}
.app-theme-dark {
  --legend-text-color: #ffffff; /* 白色文字 */
}
.app-theme-light {
  --legend-text-color: #000000; /* 黑色文字 */
}
.legend-item.disabled {
  opacity: 0.5; /* 统一变淡 */
  /* 也可以用 filter 变灰 */
  /* filter: grayscale(100%); */
}

.legend-item .color-box {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  display: inline-block;
  border-radius: 2px;
}

.legend-item.legend-fade:not(.disabled) {
  opacity: 0.3;
}
</style>
